import { FC } from "react";

type IProps = {
  stroke?: string;
};

const CircleWaring: FC<IProps> = ({ stroke = "#FAAD14" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={73}
      height={71}
      viewBox="0 0 73 71"
      fill="none"
    >
      <path
        d="M36.4999 65.9168C53.2986 65.9168 66.9166 52.2988 66.9166 35.5002C66.9166 18.7015 53.2986 5.0835 36.4999 5.0835C19.7013 5.0835 6.08325 18.7015 6.08325 35.5002C6.08325 52.2988 19.7013 65.9168 36.4999 65.9168Z"
        stroke={stroke}
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 47.6667V35.5"
        stroke={stroke}
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 23.3335H36.5304"
        stroke={stroke}
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleWaring;
